// Pre-baked editorial email templates for the BrushBasics broadcast tool.
// Each template's HTML is rendered INSIDE the editorial wrapper (header + footer)
// that the backend (server.py · email_broadcast) wraps around it. Keep markup simple:
// <h1>, <h2>, <p>, <ul>, <li>, <a>, <img>, and inline styles for spacing only.

const SITE_URL = "https://makeupbrushbasics.com";

export const EMAIL_TEMPLATES = [
  {
    id: "launch-warm",
    label: "Launch · Warm (subscribers, ~150 words)",
    subject: "An editorial guide to every brush in your kit.",
    preheader: "30 brushes, decoded. One quiet read.",
    html: `<h1>The brush in your drawer has a name.</h1>
<p>Most of us own a handful of makeup brushes we&rsquo;ve never quite figured out &mdash; the soft tapered one, the stubby flat one, the angled one nobody ever explained.</p>
<p>So we built <strong>BrushBasics</strong>: a calm, editorial guide that finally tells you what each brush is for, and exactly how to use it. No trends. No noise. Just considered technique, beautifully laid out.</p>
<h2 style="margin-top:24px">Inside the guide</h2>
<ul style="line-height:1.7;color:#5C5855;padding-left:18px;font-size:15px">
  <li>A curated catalog of <strong>30 brushes</strong> &mdash; each with what it is, what it&rsquo;s for, and a 4-step how-to</li>
  <li>A 60-second <strong>Brush Finder Quiz</strong> that recommends the right brushes for your routine</li>
  <li><strong>Ask the Brush Expert</strong> &mdash; a pocket makeup artist for late-night &ldquo;wait, which brush?&rdquo; moments</li>
  <li>The <strong>Tutorial Vault</strong>, <strong>Brush ID</strong>, and <strong>Look Builder</strong> for when you want to go deeper</li>
  <li>And a new daily series: <strong>30 Brushes in 30 Days</strong> &mdash; one brush, one lesson, delivered to your inbox each morning</li>
</ul>
<p>Whether you&rsquo;re just starting out or finally ready to retire that mystery brush from 2019, there&rsquo;s something here for you.</p>
<p style="text-align:center;margin-top:28px">
  <a href="${SITE_URL}" class="btn">Open the Guide &rarr;</a>
</p>
<p style="margin-top:20px;font-size:14px;color:#8A847F"><em>P.S. The Free Guide on the homepage is a quiet, printable PDF &mdash; a good first read with morning coffee.</em></p>`,
  },
  {
    id: "cold-short",
    label: "Cold outreach · Short (~60 words)",
    subject: "30 makeup brushes, decoded — for the curious.",
    preheader: "A quiet, editorial guide to every brush in your kit.",
    html: `<h1>For the brush you&rsquo;ve never quite figured out.</h1>
<p>I run <strong>BrushBasics</strong> &mdash; an editorial guide that explains what each makeup brush actually does, and exactly how to use it. No trends, no noise. Just 30 brushes, decoded, with a quiz, a daily course, and a pocket expert if you get stuck.</p>
<p>Thought it might be useful for you (or someone in your circle).</p>
<p style="text-align:center;margin-top:28px">
  <a href="${SITE_URL}" class="btn">Take a Look &rarr;</a>
</p>
<p style="margin-top:20px;font-size:14px;color:#8A847F">No follow-ups, no list. Just one quiet introduction. &mdash; The BrushBasics Team</p>`,
  },
];
